'use client'
import { ApolloClient, InMemoryCache, ApolloProvider } from '@apollo/client'
import { ApolloLink } from 'apollo-link'
import { HttpLink } from 'apollo-link-http'
import 'whatwg-fetch'
import { useMemo } from 'react'

const ApolloClientProvider = ({ children }) => {
  const apolloClient = useMemo(() => {
    const http = new HttpLink({
      uri: '/api/contentful/graphql',
    })

    const link = ApolloLink.from([http])
    const cache = new InMemoryCache()

    return new ApolloClient({
      link,
      cache,
      devtools: {
        enabled: true,
      },
    })
  }, []) // Only create once
  return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>
}
export default ApolloClientProvider
